import { basename } from './sd-card-entries';
import { SdCardError, type SdCardEntry } from './types';
import type { PackProgress } from './pack-common';

// P3 / prismaLINE → .pdat.
// The device already writes a finished therapy.pdat. pTS imports it "as is" — a
// byte-copy + rename with day-filtering explicitly disabled (P3FileSystemImporter)
// — and only appends importInfo.txt when it's missing. We skip that append (see
// the design-intent note in pack-common.ts: functional, not full, replica) and
// pass the device's own container bytes through untouched — the safest input.

export const packP3 = async (
  entries: SdCardEntry[],
  onProgress?: PackProgress,
): Promise<Blob> => {
  const containers = entries.filter(
    (entry) => basename(entry.path).toLowerCase() === 'therapy.pdat',
  );
  if (containers.length === 0) {
    throw new SdCardError('No therapy.pdat container was found on the P3 card.');
  }
  if (containers.length > 1) {
    throw new SdCardError(
      'Multiple devices were found on the card. Please select a single device folder.',
    );
  }
  onProgress?.(100);
  return containers[0].file;
};
